import { render } from "./Hero.vue?vue&type=template&id=946ffc4c&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=946ffc4c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946ffc4c"]])

export default __exports__